import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import useSetHeaderTitle from '../../../../../hooks/useSetHeaderTitle';
import { getIntl } from '../../../../../utils/intl';
import useMedicalProfileCardsCards from '../../../../../hooks/api/useMedicalProfileCards';
import CardForm from '../../../../shared/CardForm';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

const intl = getIntl('AddCard', {
    headerTemplate: 'Add New {cardType}',
    id: 'ID Card',
    insurance: 'Insurance Card',
    description: '{cardType} Description',
    image: '{cardType} Image',
});

export type AddCardScreenOwnProps = {};

export type AddCardScreenProps = AddCardScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'add-card'>;
};

const AddCardScreen: React.FC<AddCardScreenProps> = ({
    route: {
        params: { profileId, cardType },
    },
}) => {
    const goBack = useGoBack();
    const { createIdCard, createInsuranceCard, isCreatingIdCard } = useMedicalProfileCardsCards({
        medicalProfileId: profileId,
        onCreateCardSuccess: () => {
            goBack();
        },
    });
    useSetHeaderTitle(intl('headerTemplate', { cardType: intl(cardType) }));

    return (
        <>
            <ProfileHeaderContainer profileId={profileId} omitChatButton>
                <CardForm
                    cardType={cardType}
                    isLoading={isCreatingIdCard}
                    isDisabled={isCreatingIdCard}
                    onSubmit={(value) => {
                        if (cardType === 'id') {
                            createIdCard({
                                description: value.description,
                                image: value.imageChange,
                            });
                        } else {
                            createInsuranceCard({
                                description: value.description,
                                image: value.imageChange,
                            });
                        }
                    }}
                />
            </ProfileHeaderContainer>
        </>
    );
};

export default React.memo(AddCardScreen);
